// Settings — operator profile + password reset link + sign-out.

import { getHostedUiUrl, useAuth } from "../lib/auth";
import { buttonStyle, Card, PageHeader, tokens } from "../lib/theme";
import DebtTierEditor from "../components/DebtTierEditor";
import SmsSendDelayEditor from "../components/SmsSendDelayEditor";

export default function Settings() {
  const { user, signOut } = useAuth();
  const hosted = getHostedUiUrl();

  return (
    <div>
      <PageHeader
        title="Settings"
        subtitle="Debt tiers + SMS send delay + operator profile"
      />

      {/* Debt-tier code mapping (operator-editable). */}
      <DebtTierEditor />

      {/* Global SMS send-delay (minutes; operator-editable). */}
      <SmsSendDelayEditor />

      <Card title="Profile" style={{ marginBottom: tokens.space.xl }}>
        <dl
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: tokens.space.lg,
            margin: 0,
          }}
        >
          <Field label="Username">{user?.username ?? "—"}</Field>
          <Field label="Email">{user?.email ?? "—"}</Field>
        </dl>
      </Card>
      <Card title="Password" style={{ marginBottom: tokens.space.xl }}>
        {hosted ? (
          <a
            href={hosted}
            target="_blank"
            rel="noreferrer"
            style={{ ...buttonStyle("ghost"), textDecoration: "none" }}
          >
            Change password via Cognito hosted UI ↗
          </a>
        ) : (
          <p style={{ color: tokens.color.fg2, margin: 0 }}>
            Hosted UI not configured. Set <code>VITE_COGNITO_HOSTED_UI_URL</code>{" "}
            to enable password change.
          </p>
        )}
      </Card>
      <Card title="Session">
        <button
          type="button"
          onClick={() => void signOut()}
          style={buttonStyle("danger")}
        >
          Sign out
        </button>
      </Card>
    </div>
  );
}

function Field({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div>
      <dt
        style={{
          fontSize: tokens.font.size.xs,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: tokens.color.fg1,
          fontWeight: 600,
          marginBottom: tokens.space.xs,
        }}
      >
        {label}
      </dt>
      <dd
        style={{
          margin: 0,
          color: tokens.color.fg0,
          fontSize: tokens.font.size.lg,
          fontWeight: 500,
        }}
      >
        {children}
      </dd>
    </div>
  );
}
